import { Provider as AnalyticsProvider } from '@carvana/analytics';
import { ConsentProvider, ConsentKeys } from '@carvana/core-consent';
import { AnalyticsProvider as EventableAnalytics } from '@carvana/eventable-clickstream';
import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { LaunchDarklyProvider } from '|/app/services/launch-darkly';
import { ExperimentProvider } from '|/helpers/experiment';
import store from '~/library/store/src/store';
import libraryTheme from '~/library/styles/src/theme';
import { UIProvider } from '../../../library/helpers/src';
import { AnalyticsConfig } from '../../../library/store/src';
import {
  DevicePlatformProvider,
  MobileNavigationRailContextProvider,
  PurchaseProvider,
  SummaryContextProvider,
  SupportContactMfeContextProvider,
  UserInitializationProvider
} from '.';
import { ModalContextProvider } from '../app/modals';
import { NavigationBlockContextProvider } from '.';
import { SimpleAppFrameworkContextProvider } from '../helpers/app-framework';
import { FormStateContextProvider } from '.';

const defaultProps = {
  devicePlatform: ''
};

const SiteProviders: React.FC<React.PropsWithChildren<typeof defaultProps>> = ({
  devicePlatform,
  children
}) => (
  <Provider store={store}>
    <EventableAnalytics environment={process.env.NODE_ENV} projectName="PurchaseUI" track="TXN">
      <ConsentProvider
        environment={process.env.CVNA_APP_ENVIRONMENT}
        track="TXN"
        projectName="PurchaseUI"
        consentsRequired={[
          ConsentKeys.HardPull,
          ConsentKeys.Jumio,
          ConsentKeys.SeeMyTermsAgreement,
          ConsentKeys.CosignerSeeMyTermsAgreement,
          ConsentKeys.SoftPull,
          ConsentKeys.RootInsurance,
          ConsentKeys.CreateAccount,
          ConsentKeys.Esign,
          ConsentKeys.NRSF,
          ConsentKeys.MarylandNRSF
        ]}
      >
        <LaunchDarklyProvider>
          <ExperimentProvider>
            <UserInitializationProvider>
              <DevicePlatformProvider platform={devicePlatform}>
                <PurchaseProvider>
                  <MobileNavigationRailContextProvider>
                    <SimpleAppFrameworkContextProvider>
                      <NavigationBlockContextProvider>
                        <ModalContextProvider>
                          <SummaryContextProvider>
                            <SupportContactMfeContextProvider>
                              <AnalyticsProvider configs={AnalyticsConfig}>
                                <ThemeProvider theme={libraryTheme}>
                                  <UIProvider>
                                    <FormStateContextProvider>{children}</FormStateContextProvider>
                                  </UIProvider>
                                </ThemeProvider>
                              </AnalyticsProvider>
                            </SupportContactMfeContextProvider>
                          </SummaryContextProvider>
                        </ModalContextProvider>
                      </NavigationBlockContextProvider>
                    </SimpleAppFrameworkContextProvider>
                  </MobileNavigationRailContextProvider>
                </PurchaseProvider>
              </DevicePlatformProvider>
            </UserInitializationProvider>
          </ExperimentProvider>
        </LaunchDarklyProvider>
      </ConsentProvider>
    </EventableAnalytics>
  </Provider>
);

export default SiteProviders;
